var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgAddPicture = function SvgAddPicture(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7996 5.46309C15.4742 5.46309 14.3996 6.5376 14.3996 7.86309C14.3996 9.18857 15.4742 10.2631 16.7996 10.2631C18.1251 10.2631 19.1996 9.18857 19.1996 7.86309C19.1996 6.5376 18.1251 5.46309 16.7996 5.46309Z",
    fill: "#499CE0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.000366211 3.06309C-0.000366211 1.7376 1.07415 0.663086 2.39963 0.663086H21.5996C22.9251 0.663086 23.9996 1.7376 23.9996 3.06309V22.2631C23.9996 22.4288 23.9828 22.5905 23.9509 22.7468C23.9036 22.978 23.823 23.1971 23.7144 23.399C23.3093 24.1515 22.5142 24.6631 21.5996 24.6631H2.39963C1.07415 24.6631 -0.000366211 23.5886 -0.000366211 22.2631V3.06309ZM7.75841 5.69051L7.19963 5.13174L1.59963 10.7317V3.06309C1.59963 2.62126 1.95781 2.26309 2.39963 2.26309H21.5996C22.0415 2.26309 22.3996 2.62126 22.3996 3.06309V16.6631H18.7311L7.76538 5.6974C7.76307 5.69509 7.76074 5.69279 7.75841 5.69051Z",
    fill: "#499CE0"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAddPicture);
export { ForwardRef as ReactComponent };